<template>
  <client-only>
    <v-checkbox v-model="similarJobsModel" color="orange" text class="black--text">
      <span
        slot="label"
        class="black--text display-16 d-inline-flex px-2"
      >{{ cvPopup.SendToSimilarJobs }}</span>
    </v-checkbox>
  </client-only>
</template>

<script>
import { t } from '@/store/modules/homeDrushim/constantsContent'

export default {
  props: {
    similar: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      cvPopup: t('titles.CV_Popup'),
      similarJobsModel: true
    }
  },

  watch: {
    similarJobsModel() {
      this.applyTerms()
    }
  },
  mounted() {
    this.updateSimilar()
  },

  methods: {
    updateSimilar() {
      this.similarJobsModel = this.similar
    },

    applyTerms() {
      /**
       * @param {Boolean} this.similarJobsModel checkbox value
       * emit to CVPopup.vue
       */
      this.$nuxt.$emit('sendToSimilar', this.similarJobsModel)
    }
  }
}
</script>
